export default {"src":"/_next/static/media/running.95fdcff8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};